import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Paper,
} from "@mui/material";

const ReusableTable = ({
  data,
  handleInputChange,
  placeholders,
  errors,
  type,
  disabled,
}) => {
  const label = type === "workers" ? "workers" : "employees";

  const headerStyle = {
    backgroundColor: "#1C486B",
    color: "white",
    fontWeight: "bold",
    borderRight: "1px solid white",
  };

  return (
    <TableContainer
      component={Paper}
      sx={{
        mb: 3,
        borderRadius: "10px",
        width: "99%",
        marginLeft: "0.9rem",
      }}
    >
      <Table sx={{ border: "1px solid #ddd" }} size="small">
        <TableHead>
          <TableRow>
            <TableCell rowSpan={2} sx={headerStyle}>
              Category
            </TableCell>
            <TableCell colSpan={3} sx={headerStyle}>
              Current Financial Year
            </TableCell>
            <TableCell colSpan={3} sx={{ ...headerStyle, borderRight: "none" }}>
              Previous Financial Year
            </TableCell>
          </TableRow>
          <TableRow>
            {[
              "Total",
              "No. of covered",
              "%",
              "Total",
              "No. of covered",
              "%",
            ].map((labelText, i) => (
              <TableCell
                key={i}
                sx={{
                  ...headerStyle,
                  borderRight: i === 5 ? "none" : "1px solid white",
                }}
              >
                {labelText} {labelText === "%" ? "" : label}
                {/* {i < 3 ? label : ""} */}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>

        <TableBody>
          {data.map((row, rowIndex) => (
            <TableRow key={row.category}>
              <TableCell
                sx={{
                  borderRight: "1px solid #ddd",
                  fontWeight:
                    row.category.trim() === "Total" ? "bold" : "normal",
                }}
              >
                {row.category}
              </TableCell>

              {["currentYear", "previousYear"].map((year, yearIndex) =>
                row[year]?.map((value, colIndex) => {
                  const isPercentColumn = colIndex === 2;
                  const isTotalRow = row.category.trim() === "Total";

                  return (
                    <TableCell
                      key={`${year}-${colIndex}`}
                      sx={{
                        borderRight: "1px solid #ddd",
                        backgroundColor:
                          isPercentColumn || isTotalRow
                            ? "#DBDBDB"
                            : "transparent",
                      }}
                    >
                      <TextField
                        variant="outlined"
                        size="small"
                        value={value ?? ""}
                        onChange={(e) =>
                          handleInputChange(
                            rowIndex,
                            year,
                            colIndex,
                            e.target.value,
                          )
                        }
                        placeholder={
                          isTotalRow
                            ? isPercentColumn
                              ? "%"
                              : "Total"
                            : placeholders[yearIndex][colIndex]
                        }
                        fullWidth
                        InputProps={{
                          style: { border: "none", outline: "none" },
                        }}
                        sx={{
                          "& .MuiOutlinedInput-root": {
                            "& fieldset": { border: "none" },
                          },
                        }}
                        disabled={isPercentColumn || disabled}
                        error={!!errors[`${rowIndex}-${year}-${colIndex}`]}
                      />
                    </TableCell>
                  );
                }),
              )}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default ReusableTable;
